import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types';
export type SimpleDetailsProps = CommonProps & {
  variant: 'simple';
  SummaryComponent: ReactNode;
};
export function SimpleDetails(t0) {
  const $ = _c(28);
  const {
    children,
    detailsProps: t1,
    summaryComponentProps: t2,
    SummaryComponent
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const detailsProps = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const summaryComponentProps = t4;
  let restDetailsProps;
  let sxDetailsProps;
  if ($[4] !== detailsProps) {
    ({
      sx: sxDetailsProps,
      ...restDetailsProps
    } = detailsProps);
    $[4] = detailsProps;
    $[5] = restDetailsProps;
    $[6] = sxDetailsProps;
  } else {
    restDetailsProps = $[5];
    sxDetailsProps = $[6];
  }
  let restSummaryComponentProps;
  let sxSummaryComponentProps;
  if ($[7] !== summaryComponentProps) {
    ({
      sx: sxSummaryComponentProps,
      ...restSummaryComponentProps
    } = summaryComponentProps);
    $[7] = summaryComponentProps;
    $[8] = restSummaryComponentProps;
    $[9] = sxSummaryComponentProps;
  } else {
    restSummaryComponentProps = $[8];
    sxSummaryComponentProps = $[9];
  }
  let t5;
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      transition: "transform 0.3s"
    };
    t6 = {
      transform: "rotate(-180deg)"
    };
    t7 = {
      transform: "rotate(0deg)"
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] !== sxDetailsProps) {
    t8 = {
      position: "relative",
      "& .expand-icon": t5,
      "&[open] .expand-icon": t6,
      "&:not([open]) .expand-icon": t7,
      ...sxDetailsProps
    };
    $[13] = sxDetailsProps;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t10;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      display: "none"
    };
    t10 = {
      display: "none"
    };
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] !== sxSummaryComponentProps) {
    t11 = {
      listStyle: "none",
      listStyleType: "none",
      "::-webkit-details-marker": t9,
      "::marker": t10,
      cursor: "pointer",
      ...sxSummaryComponentProps
    };
    $[17] = sxSummaryComponentProps;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== SummaryComponent || $[20] !== restSummaryComponentProps || $[21] !== t11) {
    t12 = <Box component="summary" data-testid="detail-summary" sx={t11} {...restSummaryComponentProps}>{SummaryComponent}</Box>;
    $[19] = SummaryComponent;
    $[20] = restSummaryComponentProps;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== children || $[24] !== restDetailsProps || $[25] !== t12 || $[26] !== t8) {
    t13 = <Box sx={t8} component="details" {...restDetailsProps}>{t12}{children}</Box>;
    $[23] = children;
    $[24] = restDetailsProps;
    $[25] = t12;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}